import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('r2_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [loading, setLoading] = useState(true);

  // Check if token is still valid on mount
  useEffect(() => {
    const token = api.getToken();
    if (token) {
      api.getMe()
        .then(u => {
          setUser(u);
          localStorage.setItem('r2_user', JSON.stringify(u));
        })
        .catch(() => {
          api.logout();
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const result = await api.login(email, password);
    setUser(result.user);
    localStorage.setItem('r2_user', JSON.stringify(result.user));
    return result;
  }, []);

  const register = useCallback(async (data) => {
    const result = await api.register(data);
    setUser(result.user);
    localStorage.setItem('r2_user', JSON.stringify(result.user));
    return result;
  }, []);

  const logout = useCallback(() => {
    api.logout();
    setUser(null);
    localStorage.removeItem('r2_user');
  }, []);

  const refreshUser = useCallback(async () => {
    const u = await api.getMe();
    setUser(u);
    localStorage.setItem('r2_user', JSON.stringify(u));
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
